import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-primary mb-5 text-3xl font-bold" }, " ¡Hagamos un trato! ", -1)
const _hoisted_2 = { class: "flex flex-col px-5 py-5 bg-white shadow-lg rounded-lg md:flex-row" }
const _hoisted_3 = { class: "inline-flex items-center flex-1 mr-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "inline-flex text-xl font-bold text-left text-gris80" }
const _hoisted_6 = { class: "mt-4 md:mt-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold md:text-left text-primary" }, " Saldo total de la obligación ", -1)
const _hoisted_8 = { class: "text-xl font-bold md:text-left text-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "py-5 text-gris80 text-center text-base" }, [
  /*#__PURE__*/_createTextVNode(" Elija la opción en montos y plazos que más le convenga para "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "recuperar su tranquilidad financiera.")
], -1)
const _hoisted_10 = { class: "flex flex-col justify-between pb-4 md:flex-row" }
const _hoisted_11 = {
  key: 0,
  class: "w-full text-lg font-bold text-center text-secondary px-6"
}
const _hoisted_12 = { class: "w-full text-lg font-bold text-center text-secondary px-6 pb-3" }
const _hoisted_13 = {
  key: 1,
  class: "text-xs text-gris120 text-justify px-6 pb-4"
}
const _hoisted_14 = {
  key: 2,
  class: "text-xs text-gris120 text-justify px-6"
}
const _hoisted_15 = { class: "text-center my-5 text-primary text-lg px-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-xl" }, "Pague Solo:", -1)
const _hoisted_17 = { class: "font-bold text-xl" }
const _hoisted_18 = {
  key: 3,
  class: "text-sm text-center text-gris80 bg-lightSurface-50 h-28 align-middle"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold pt-1" }, "1 Cuota de", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "+", -1)
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = {
  key: 4,
  class: "text-sm text-center text-gris80 bg-lightSurface-50 h-28 align-middle"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold pt-8" }, "1 Cuota de", -1)
const _hoisted_25 = { class: "inline-block" }
const _hoisted_26 = { class: "my-3 text-left px-6" }
const _hoisted_27 = { class: "flex justify-between" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold text-gris80" }, "Valor descuento:", -1)
const _hoisted_29 = { class: "text-xs text-gris80" }
const _hoisted_30 = { class: "flex justify-between" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold text-gris80" }, "Total a pagar:", -1)
const _hoisted_32 = { class: "text-xs text-gris80" }
const _hoisted_33 = { class: "flex justify-between text-xs font-bold text-primary mt-2 border-top" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "Porcentaje de ahorro:", -1)
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "w-full text-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "flex flex-col md:flex-row justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalConfirmNegotiation = _resolveComponent("ModalConfirmNegotiation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCloseModal: _ctx.close,
          "custom-class": 'p-2 md:p-4 bg-lightSurface-50 h-4/6 mx-2 overflow-y-auto md:h-5/6 md:w-3/5'
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "object-cover w-12 h-12 mr-3 overflow-hidden rounded-full",
                  src: _ctx.portfolio?.url_logo,
                  alt: ""
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.portfolio?.bank_name), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$filters.currency(_ctx.portfolio?.total_portfolio)), 1)
              ])
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSimulator, (simulator, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["pay-option__card", [_ctx.dataSimulator.length > 2 ? 'w-max-3' : '']]),
                  key: index
                }, [
                  (simulator?.campaing === 1)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_11, _toDisplayString(_ctx.setHomologateProductsTitle(simulator?.committee || '')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.setHomologateProductsTitle(simulator?.product_name || '')), 1),
                  (simulator?.number_fee_ordinary === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Con este trato usted recibe el mejor beneficio y cancela su deuda en un solo pago. "))
                    : (_openBlock(), _createElementBlock("p", _hoisted_14, " Es la oportunidad de pagar su deuda con una cuota inicial y " + _toDisplayString(simulator?.number_fee_ordinary) + " cuotas mensuales que se ajusten a sus ingresos. ", 1)),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$filters.currency(_ctx.setDiscount(simulator?.total_value_to_pay || 0))), 1)
                  ]),
                  (simulator?.number_fee_ordinary !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(simulator?.initial_fee_value)) + " ", 1),
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("p", _hoisted_22, _toDisplayString(simulator?.number_fee_ordinary) + " cuotas de ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(simulator?.ordinary_fee_value)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$filters.currency(simulator?.initial_fee_value)), 1)
                      ])),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$filters.currency(simulator?.discount_value_on_debt)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$filters.currency(simulator?.total_value_to_pay)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString(simulator?.savings_percentage) + "%", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.confirmAcceptConditions(simulator)),
                      class: "w-10/12 h-12 px-4 py-2 text-base text-white rounded-lg bg-success border md:w-10/12 md:h-9 md:text-xs"
                    }, " Quiero este trato ", 8, _hoisted_37)
                  ])
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                type: "button",
                target: "_blank",
                rel: "noopener",
                class: "w-full text-center px-4 py-2 mt-3 md:mt-0 text-sm text-white rounded-lg bg-primary border md:w-52 md:text-xs xl:text-sm h-10 md:h-11 lg:h-10 md:mr-2 xl:mr-8",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.actionChat && _ctx.actionChat(...args)))
              }, " Chat en línea por WhatsApp "),
              _createElementVNode("button", {
                type: "button",
                target: "_blank",
                rel: "noopener",
                class: "w-full text-center px-4 py-2 mt-3 md:mt-0 text-sm text-white rounded-lg bg-secondary border md:w-52 md:text-xs xl:text-sm h-10 md:h-11 lg:h-10",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.actionCallYou && _ctx.actionCallYou(...args)))
              }, " Prefieres que te llamemos ")
            ])
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalConfirmNegotiation, {
      "is-visible": _ctx.showModalConfirmNegotiation,
      "current-negotiation": _ctx.currentNegotiation,
      onConfirm: _ctx.aceptCondition,
      onMoreTime: _ctx.moreTime,
      onClose: _ctx.closeModalConfirmNegotiation
    }, null, 8, ["is-visible", "current-negotiation", "onConfirm", "onMoreTime", "onClose"])
  ], 64))
}